import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SubscriptionsLogicComponent } from './subscriptions-logic.component';

export const /** @type {?} */ routes: Routes = [
  { path: '', component: SubscriptionsLogicComponent }
 ];
export class SubscriptionsRoutingModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [RouterModule]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function SubscriptionsRoutingModule_tsickle_Closure_declarations() {
/** @type {?} */
SubscriptionsRoutingModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SubscriptionsRoutingModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
